module.exports = __webpack_public_path__ + "static/docker-59302eeeef8a58131fb8c45bf9ad107f.png";